import React, {Component} from 'react';
import classNames from 'classnames';

import moment from 'moment';
import momentDF from 'moment-duration-format';

import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as GTFSActions from 'ducks/gtfs';
import * as MapActions from 'ducks/map';

import api from 'utils/api';

const mapDispatchToProps = dispatch => bindActionCreators({...GTFSActions, ...MapActions}, dispatch);

@connect(null, mapDispatchToProps)
class TimetableView extends Component {
    initialState = {
        route: '',
        stop: '',
        timetables: [],
        liveDepartures: {},
    };

    state = this.initialState;

    componentDidMount = () => {
        this.loadTimetable();
    };

    clearState = () => {
        this.setState(this.initialState);
    };

    componentDidUpdate = (prevProps) => {
        const prevParams = prevProps.match.params;
        const {params} = this.props.match;
        if (
            (prevParams.stop !== params.stop) ||
            (prevParams.route !== params.route)
        ) {
            if (this.timer) {
                clearInterval(this.timer);
            }
            this.loadTimetable();
        }
    };

    loadTimetable = () => {
        this.clearState();
        const {stop, route} = this.props.match.params;

        api.timetable.fetch(null, {stop, route}).then(data => {
            const {route, stop, timetables} = data;
            this.setState({
                route,
                stop,
                timetables,
            });

            this.props.setViewport({
                center: {
                    lat: parseFloat(stop.stop_lat),
                    lng: parseFloat(stop.stop_lon),
                },
            });
            this.fetchLiveTimes();
            this.timer = setInterval(() => {
                this.fetchLiveTimes();
            }, 5000);
        });
    };

    componentWillUnmount = () => {
        clearInterval(this.timer);
    };

    fetchLiveTimes = () => {
        const {stop, route} = this.props.match.params;

        api.live.fetch(null, {stop_id: stop, route_id: route}).then(liveDepartures => {
            const departures = {};
            liveDepartures.map(dep => {
                departures[dep.stoptime_id] = {
                    ...dep,
                    liveEstimated: moment(dep.estimated, 'HH:mm:ss'),
                    liveScheduled: moment(dep.scheduled, 'HH:mm:ss'),
                };
            });

            this.setState({
                liveDepartures: {
                    ...this.state.liveDepartures,
                    ...departures,
                }
            })
        });
    };

    onClick = (tripId) => {
        this.props.loadTrip(tripId);
        this.props.setActiveTrip(tripId);
    };

    renderTimetable = timetable => {
        const {liveDepartures} = this.state;
        const {service, times} = timetable;

        return (
            <div className="service">
                <div className="service__name">{service}</div>
                <table className="schedule">
                    <tbody>
                        {times.map(hour => (
                            <tr key={hour.hour}>
                                <th>{hour.hour}</th>
                                <td>
                                    {hour.times.map(time => {
                                        const liveTime = liveDepartures[time.id];
                                        let title = "";

                                        if (liveTime) {
                                            const {liveScheduled, liveEstimated} = liveTime;
                                            title = liveEstimated.format('HH:mm:ss');
                                        }

                                        return (
                                            <span
                                                className={classNames(
                                                    "departure",
                                                    {
                                                        "live": liveTime,
                                                        "accessible": time.wheelchair,
                                                    }
                                                )}
                                                onClick={() => this.onClick(time.trip_id)}
                                                title={title}
                                            >
                                            {time.departure_time.split(":")[1]}
                                        </span>
                                        )
                                    })}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    };

    renderLiveDepartures = () => {
        const {liveDepartures} = this.state;

        if (Object.keys(liveDepartures).length === 0) {
            return null;
        }

        const sortedDepartures = Object.values(liveDepartures).sort((a, b) => a.liveEstimated - b.liveEstimated);

        return (
            <div className="timetable__next-departures">
                <h5 className="margin-md-top">Järgmised väljumised:</h5>
                {sortedDepartures.map(dep => (
                    <div key={dep.stoptime_id}>
                        {dep.liveEstimated.format('HH:mm:ss')}
                    </div>
                ))}
            </div>
        );
    };

    renderTimetableInfo = () => {
        const {route} = this.state;

        if (!route) {
            return null;
        }

        const {agency} = route;

        const agencyName = agency.agency_url ? (
            <a rel="noopener noreferrer" target="_blank" href={agency.agency_url}>{agency.agency_name}</a>
        ) : agency.agency_name;

        return (
            <div className="timetable__info">
                <p>Liini teenindab {agencyName}.</p>
            </div>
        )
    };

    render() {
        const {stop, route, timetables, liveDepartures} = this.state;
        return (
            <div className="timetable">
                {route ? (
                    <h1 className="timetable__route">
                        <span className="timetable__route__number">{route.route_short_name}</span>
                        <span className="timetable__route__name">{route.route_long_name}</span>
                    </h1>
                ) : null}
                {stop ? (<h2 className="timetable__stop">Peatus {stop.stop_name}</h2>) : null}
                {this.renderLiveDepartures()}
                <div className="services">
                    {timetables.map(this.renderTimetable)}
                </div>
                {this.renderTimetableInfo()}
            </div>
        );
    }
}

export default TimetableView;



// WEBPACK FOOTER //
// ./src/components/TimetableView.js